import React, { createContext, ReactNode, useContext, useState } from 'react';

interface IModalContext {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

const ModalContext = createContext<IModalContext | null>(null);

export const useModalCategory = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal должен использоваться внутри ModalProvider');
  }
  return context;
};

interface ModalProviderProps {
  children: ReactNode;
}

export const ModalProviderCategory = ({ children }: ModalProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);
  const toggle = () => setIsOpen(state => !state);

  const value = {
    isOpen,
    open,
    toggle,
    close,
  };

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>;
};
